var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.date
    ? _c(
        "div",
        { staticClass: "base-timestamp" },
        [
          _vm.useTooltip
            ? _c(
                "or-tooltip",
                {
                  attrs: { content: _vm.tooltipText },
                  model: {
                    value: _vm.isTooltipShown,
                    callback: function ($$v) {
                      _vm.isTooltipShown = $$v
                    },
                    expression: "isTooltipShown",
                  },
                },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v("\n      " + _vm._s(_vm.content) + "\n    "),
                  ]),
                ]
              )
            : _c("span", { staticClass: "text" }, [
                _vm._v("\n    " + _vm._s(_vm.content) + "\n  "),
              ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }